import React from 'react';
import { Route } from 'react-router-dom';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import BlogTable from './blog-table';
import BlogTableDetail from './blog-table-detail';
import BlogTableUpdate from './blog-table-update';
import BlogTableDeleteDialog from './blog-table-delete-dialog';

const BlogTableRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<BlogTable />} />
    <Route path="new" element={<BlogTableUpdate />} />
    <Route path=":id">
      <Route index element={<BlogTableDetail />} />
      <Route path="edit" element={<BlogTableUpdate />} />
      <Route path="delete" element={<BlogTableDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default BlogTableRoutes;
